import {prefersReducedMotion} from "./progress"

const CASES = [
  {
    from: "no-reply@acme.example",
    subject: "Reset your password",
    preview: "Use this link to choose a new password.",
    needs: false,
    why: "A password reset is a reply to a request. It does not need an unsubscribe link."
  },
  {
    from: "ship@acme.example",
    subject: "Your order is on the way",
    preview: "Package 1842 left the warehouse this morning.",
    needs: false,
    why: "A shipping update is transactional. It does not need an unsubscribe link."
  },
  {
    from: "news@acme.example",
    subject: "Your monthly newsletter",
    preview: "Stories and updates from Acme this month.",
    needs: true,
    why: "A monthly newsletter is bulk mail. It needs an unsubscribe link."
  },
  {
    from: "billing@acme.example",
    subject: "Your trial ends tomorrow",
    preview: "Upgrade today and keep every seat you added.",
    needs: true,
    why: "An upgrade pitch is promotional, even when a trial date is the subject."
  },
  {
    from: "security@acme.example",
    subject: "New sign-in on your account",
    preview: "Someone signed in from 198.51.100.20.",
    needs: false,
    why: "A security alert is transactional. It does not need an unsubscribe link."
  },
  {
    from: "product@acme.example",
    subject: "New features this month",
    preview: "A roundup of what shipped, sent to every user.",
    needs: true,
    why: "A feature roundup sent to all users is a newsletter. It needs an unsubscribe link."
  }
]

function verdictFor(score, total) {
  if (score === total) return "You can tell a request from a pitch."
  if (score >= 4) return "The upgrade pitch is the one that looks transactional."
  return "When the mail sells something, include the link."
}

function setBusy(root, busy) {
  root.querySelectorAll("[data-learn-judge]").forEach((button) => {
    button.disabled = busy
  })
}

function paintCard(root, item, animate) {
  const card = root.querySelector("[data-learn-card]")
  const from = root.querySelector("[data-learn-from]")
  const subject = root.querySelector("[data-learn-subject]")
  const preview = root.querySelector("[data-learn-preview]")
  if (from) from.textContent = item.from
  if (subject) subject.textContent = item.subject
  if (preview) preview.textContent = item.preview
  if (!card) return
  card.style.transform = ""
  card.style.opacity = "1"
  if (!animate || prefersReducedMotion()) return
  card.style.transition = "none"
  card.style.transform = "translateY(10px)"
  card.style.opacity = "0"
  window.requestAnimationFrame(() => {
    card.style.transition = "transform 280ms ease-out, opacity 280ms ease-out"
    card.style.transform = "translateY(0)"
    card.style.opacity = "1"
  })
}

function stateOf(root) {
  return {
    index: Number(root.dataset.learnIndex || 0),
    score: Number(root.dataset.learnScore || 0)
  }
}

function writeState(root, state) {
  root.dataset.learnIndex = String(state.index)
  root.dataset.learnScore = String(state.score)
  const step = root.querySelector("[data-learn-step]")
  if (step) step.textContent = `${Math.min(state.index + 1, CASES.length)} of ${CASES.length}`
}

function finish(root, state) {
  const card = root.querySelector("[data-learn-card]")
  const choices = root.querySelector("[data-learn-choices]")
  const step = root.querySelector("[data-learn-step]")
  const end = root.querySelector("[data-learn-end]")
  if (card) card.hidden = true
  if (choices) choices.hidden = true
  if (step) step.hidden = true
  if (end) end.hidden = false
  const score = root.querySelector("[data-learn-score]")
  if (score) score.textContent = `${state.score} of ${CASES.length}`
  const verdict = root.querySelector("[data-learn-verdict]")
  if (verdict) verdict.textContent = verdictFor(state.score, CASES.length)
}

function reset(root) {
  writeState(root, {index: 0, score: 0})
  const why = root.querySelector("[data-learn-why]")
  if (why) {
    why.textContent = ""
    why.classList.remove("text-good", "text-bad")
    why.classList.add("text-ink-muted")
  }
  const card = root.querySelector("[data-learn-card]")
  const choices = root.querySelector("[data-learn-choices]")
  const step = root.querySelector("[data-learn-step]")
  const end = root.querySelector("[data-learn-end]")
  if (card) card.hidden = false
  if (choices) choices.hidden = false
  if (step) step.hidden = false
  if (end) end.hidden = true
  paintCard(root, CASES[0], false)
  setBusy(root, false)
}

function answer(root, value) {
  const state = stateOf(root)
  const item = CASES[state.index]
  if (!item || root.dataset.learnBusy === "true") return
  root.dataset.learnBusy = "true"
  setBusy(root, true)
  const correct = item.needs === (value === "yes")
  if (correct) state.score += 1
  const why = root.querySelector("[data-learn-why]")
  if (why) {
    why.classList.remove("text-ink-muted", "text-good", "text-bad")
    why.classList.add(correct ? "text-good" : "text-bad")
    why.textContent = item.why
  }
  writeState(root, state)
  window.setTimeout(() => {
    state.index += 1
    writeState(root, state)
    root.dataset.learnBusy = "false"
    if (state.index >= CASES.length) {
      finish(root, state)
      return
    }
    paintCard(root, CASES[state.index], true)
    setBusy(root, false)
  }, prefersReducedMotion() ? 0 : 280)
}

export function mount(root) {
  writeState(root, {index: 0, score: 0})
  root.querySelectorAll("[data-learn-judge]").forEach((button) => {
    button.addEventListener("click", () => answer(root, button.dataset.learnJudge))
  })
  root.querySelector("[data-learn-retry]")?.addEventListener("click", () => reset(root))
}
